var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 73,
    viewBox: "0 0 44 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0206 71.5838C4.13932 62.619 -2.60406 47.3683 5.28936 29.4603C14.7498 7.99696 42.5001 4.70654 42.5001 4.70654M42.5001 4.70654L32.2698 1.55445M42.5001 4.70654L35.1145 12.9347",
    stroke: "#082980",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioArrow);
export default __webpack_public_path__ + "static/media/audio_arrow.07449eba94ae83adb8174577cc1f1ce6.svg";
export { ForwardRef as ReactComponent };